import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Icons } from '../components/common';
import toast from 'react-hot-toast';

export default function LoginPage() {
  const { login }   = useAuth();
  const navigate    = useNavigate();
  const [form, setForm]     = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.username, form.password);
      toast.success('Welcome back!');
      navigate('/');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-bg-pattern" />

      {/* Left branding panel */}
      <div className="login-left">
        <div className="login-brand">Closet by<br />Shaila Sara</div>
        <div className="login-brand-sub">Management System</div>
        <p className="login-tagline">
          A complete solution for inventory, purchasing,<br />invoicing and delivery management.
        </p>
      </div>

      {/* Right form panel */}
      <div className="login-right">
        <div className="login-card">
          <h1 className="login-card-title">Sign in</h1>
          <p className="login-card-sub">Enter your credentials to continue</p>

          <form onSubmit={handleSubmit} autoComplete="off">
            <div className="login-input-group">
              <label className="login-input-label">Username</label>
              <div className="login-input-wrap">
                <Icons.User size={15} className="login-input-icon" />
                <input
                  type="text"
                  value={form.username}
                  placeholder="admin"
                  autoFocus
                  autoComplete="username"
                  onChange={e => setForm(f => ({ ...f, username: e.target.value }))}
                  required
                />
              </div>
            </div>

            <div className="login-input-group">
              <label className="login-input-label">Password</label>
              <div className="login-input-wrap">
                <Icons.Lock size={15} className="login-input-icon" />
                <input
                  type="password"
                  value={form.password}
                  placeholder="••••••••"
                  autoComplete="current-password"
                  onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
                  required
                />
              </div>
            </div>

            <button className="login-btn" type="submit" disabled={loading}>
              {loading ? 'Signing in…' : 'Sign In'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
